import { createTheme } from "@mui/material/styles";
import "@mui/x-date-pickers/themeAugmentation";
import { colorSchemes } from "./color-schemes";
import { components } from "./components/components";
import { shadows } from "./shadows";
import { typography } from "./typography";
import type { Theme } from "./types";
import type { Brand } from "@/types/brand.types";

function customCreateTheme(brand: Brand): Theme {
	const theme = createTheme({
		breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440 } },
		colorSchemes: colorSchemes(brand),
		components,
		cssVariables: {
			colorSchemeSelector: "class",
		},
		direction: "ltr",
		shadows,
		shape: { borderRadius: 8 },
		typography: {
			...typography,
			htmlFontSize: 16, // Explicitly tell MUI our HTML font size
		},
	});

	return theme;
}

export { customCreateTheme as createTheme };
